import { useReducer, useCallback, useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { logout } from '../store';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const httpReducer = (curHttpState, action) => {
  switch (action.type) {
    case 'SEND':
      return {
        loading: true,
        error: null,
        data: null,
      };
    case 'RESPONSE':
      return {
        ...curHttpState,
        loading: false,
        data: action.responseData,
      };
    case 'ERROR':
      return { loading: false, error: action.errorMessage };
    case 'CLEAR':
      return initialState;
    default:
      throw new Error('Should not be reached!');
  }
};

const BaseURL = 'http://213.233.177.17:8022/';

const useHttp = () => {
  const [httpState, dispatchHttp] = useReducer(httpReducer, initialState);
  const dispatch = useDispatch();

  const [shoot, setShoot] = useState(false);
  useEffect(() => {
    if (shoot) {
      dispatch(logout());
    }
  }, [dispatch, shoot]);

  const clear = useCallback(() => dispatchHttp({ type: 'CLEAR' }), []);

  const sendRequest = useCallback((url, method, body, header) => {
    dispatchHttp({ type: 'SEND' });
    fetch(BaseURL + url, {
      method: method,
      body: body,
      headers: {
        ...header,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        const detail = responseData.detail;
        if (
          responseData &&
          (detail === 'Invalid Token' ||
            detail === 'Access token expired' ||
            detail === 'Given token not valid for any token type')
        ) {
          setShoot(true);
        }

        dispatchHttp({
          type: 'RESPONSE',
          responseData: responseData,
        });
      })
      .catch((error) => {
        dispatchHttp({
          type: 'ERROR',
          errorMessage: `Something went wrong! -> ${error}`,
        });
      });
  }, []);

  return {
    isLoading: httpState.loading,
    data: httpState.data,
    error: httpState.error,
    sendRequest: sendRequest,
    clear: clear,
  };
};

export default useHttp;
